/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'rating-3': {
    width: 44,
    height: 44,
    viewBox: '0 0 44 44',
    data: `<defs><clipPath id="svgicon_rating-3_a"><path pid="0" d="M0 0h44v44H0z"/></clipPath></defs><g clip-path="url(#svgicon_rating-3_a)"><g transform="translate(.037 17.296)" _fill="currentColor"><circle pid="1" cx="5" cy="5" r="5" transform="translate(-.037 -.296)"/><circle pid="2" cx="5" cy="5" r="5" transform="translate(16.963 -.296)"/><circle pid="3" cx="5" cy="5" r="5" transform="translate(33.963 -.296)"/></g></g>`
  }
})
/* tslint:enable */
